import { Route } from 'types/route.type';
import EditBestMixFeed from './components/edit-best-mix-feed';
import ListBestMixFeeds from './list-best-mix-feeds';

export const routes: Route[] = [
  {
    path: '/feed-management/bestmix-feeds',
    component: ListBestMixFeeds,
    id: 'feedManagement.navigation.listBestMixFeeds',
  },
  {
    path: '/feed-management/bestmix-feeds/:code',
    component: EditBestMixFeed,
  },
];
